import React from "react";
import PropTypes from "prop-types";
import { parse } from "qs";

import { HeaderContext } from "config/contexts";
import { STREAM_TYPE, HEADER_LEVELS } from "config/constants";
import Stream from "stream/containers/Stream";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import LatestStories from "components/Library/LatestStories";
import PermalinkCard from "cards/containers/PermalinkCard";
import PermalinkStreamHelmet from "stream/components/PermalinkStreamHelmet";
import Preview from "stream/containers/Preview/Preview";
import StreamCap from "stream/containers/StreamCap";

const PermalinkStream = ({ location, match }) => {
  const parsedQs = parse(location.search.slice(1));
  const isPreview = !!parsedQs.preview;

  return (
    <>
      <HeaderContext.Provider value={HEADER_LEVELS.PERMALINK_STREAM}>
        <StandardLayout
          main={
            isPreview ? (
              <Preview
                permalinkId={match.params.id}
                revision={parsedQs.revision}
              />
            ) : (
              <>
                <PermalinkStreamHelmet id={match.params.id} />
                <StreamCap />
                <Stream
                  type={STREAM_TYPE.PERMALINK}
                  lookup={match.params.id}
                  streamOverride={parsedQs.stream}
                  onlyShowTitleForA11y={true}
                  contentComponent={PermalinkCard}
                  serverRenderedNodeCount={1}
                  trackFirstItem={true}
                  disablePaginationParam={true}
                />
              </>
            )
          }
          complementary={<LatestStories />}
          mainAriaLabel="Stories"
        />
      </HeaderContext.Provider>
    </>
  );
};

PermalinkStream.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};

export default PermalinkStream;
